import React, { useEffect, useRef, useState } from "react";
import Text from "shared/components/data-display/mui/Text";
import PropTypes from "prop-types";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import DownCaret from "shared/components/utils/icons/DownCaret";
import IconButton from "@material-ui/core/IconButton";
import { truncateText } from "shared/helper-functions/string/truncateText";
import { useStylesForMenu } from "shared/styles/makeStyles";
import "@szhsin/react-menu/dist/index.css";
import MoreMenu from "./MoreMenu";
import { MenuItem, Popper } from "@material-ui/core";
import { Container, DownCaretWrapper, MenuItemLabel, SelectedLabel, Trigger } from "./SelectMenu.styles";

export const SelectMenu = (props) => {
    const {
        triggerLength,
        label,
        items,
        itemAction,
        clearAction,
        moreMenuOptions,
        border,
        reload,
    } = props;
    const classes = useStylesForMenu();
    const [selectedItem, setSelectedItem] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const ref = useRef(null);

    useEffect(() => {
        document
            .getElementsByClassName("modal")[0]
            ?.removeAttribute("tabindex");
    }, []);

    useEffect(() => {
        let isSelected = false;
        if (items.length > 0) {
            items.forEach(function (item) {
                if (item.default && item.default === true) {
                    isSelected = true;
                    setSelectedItem(item);
                }
            });
            if (!isSelected) {
                setSelectedItem(null);
            }
        }
    }, [items, reload]);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopupClose = () => {
        if (anchorEl !== null) {
            setAnchorEl(null);
        }
    };

    const clearSelection = (e) => {
        e.stopPropagation();
        setSelectedItem(null);
        if (clearAction) {
            clearAction(e);
        }
    };

    const listItems = items.map((item) => (
        <MenuItem
            key={item.id}
            value={item.id}
            selected={selectedItem && selectedItem.id === item.id}
            onClick={(e) => (e.keepOpen = true)}
        >
            <MenuItemLabel
                onClick={function () {
                    setSelectedItem(item);
                    itemAction(item);
                    handlePopupClose();
                }}
            >
                {truncateText(item.name, 165)}
            </MenuItemLabel>
            {moreMenuOptions && (
                <MoreMenu
                    key={"moremenu" + item.id}
                    itemId={item.id}
                    itemName={item.name}
                    closeParent={handlePopupClose}
                    portal={true}
                    notHover={true}
                >
                    {moreMenuOptions}
                </MoreMenu>
            )}
        </MenuItem>
    ));

    return (
        <ClickAwayListener onClickAway={handlePopupClose}>
            <Container border={border}>
                <Trigger onClick={handleClick} width={triggerLength} ref={ref}>
                    {selectedItem ? (
                        <>
                            <SelectedLabel>{selectedItem.name}</SelectedLabel>
                            <IconButton
                                aria-label="clear"
                                onClick={clearSelection}
                                size="small"
                            >
                                X
                            </IconButton>
                        </>
                    ) : (
                        <Text variant="smallLight">{label}</Text>
                    )}
                    <DownCaretWrapper>
                        <DownCaret size="16"></DownCaret>
                    </DownCaretWrapper>
                </Trigger>
                <Popper
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handlePopupClose}
                    className={classes.selectMenu}
                >
                    {listItems}
                </Popper>
            </Container>
        </ClickAwayListener>
    );
};

SelectMenu.defaultProps = {
    triggerLength: "11rem",
};

SelectMenu.propTypes = {
    items: PropTypes.any.isRequired,
    moreMenuOptions: PropTypes.node,
    triggerLength: PropTypes.string,
    label: PropTypes.string,
    itemAction: PropTypes.func,
    clearAction: PropTypes.func,
    border: PropTypes.bool,
    reload: PropTypes.any,
};

export default SelectMenu;
